import axiosIns from '@/api/axios';
import axiosInsAcademy from '@/api/axios-ugems-academy';

// Moodle clone (backup/restore) can take up to ~5 minutes
const MOODLE_CLONE_TIMEOUT_MS = Number(process.env.VUE_APP_MOODLE_CLONE_TIMEOUT_MS || 300000);

// Get list of trainings/courses
export const GET_COURSES = (params) => {
  return axiosIns.get('/training', { params });
};

// Get course detail by ID
export const GET_COURSE_BY_ID = (id, params) => {
  // params is an optional object passed as query params, e.g. { year: 2025 }
  return axiosIns.get(`/training/${id}`, { params });
};

// Create or Update course (using POST with training_id)
export const SAVE_COURSE = (data) => {
  return axiosIns.post('/training', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Delete course
export const DELETE_COURSE = (id) => {
  return axiosIns.delete(`/training/${id}`);
};

// Clone course
export const CLONE_COURSE = (id) => {
  return axiosIns.post(`/training/${id}/clone`, {}); // empty body
};

// Submit training event confirmation (realization)
export const SUBMIT_TRAINING_EVENT = (id, data) => {
  return axiosIns.put(`/training-event/${id}`, data);
};

export const DELETE_TRAINING_EVENT = (id) => {
  return axiosIns.delete(`/training-event/${id}`);
}

// Update batch (training event)
export const UPDATE_BATCH = (id, data) => {
  return axiosIns.put(`/training-event/${id}/edit`, data);
};

// Create batch (training event) for a course
export const CREATE_BATCH = (trainingId, data) => {
  return axiosIns.post(`/training/${trainingId}/training-event`, data, {
    timeout: MOODLE_CLONE_TIMEOUT_MS
  });
};

// Duplicate batch (training event)
export const DUPLICATE_BATCH = (trainingEventId) => {
  return axiosIns.post(`/training-event/${trainingEventId}/duplicate`, {}, {
    timeout: MOODLE_CLONE_TIMEOUT_MS
  });
};

// Download template for bulk upload
export const DOWNLOAD_TEMPLATE = () => {
  return axiosIns.get('/training/download-template', {
    responseType: 'blob'
  });
};

export const DOWNLOAD_HISTORY_CATALOG_TEMPLATE = () => {
  return axiosIns.get('/training/history-catalog/download-template', {
    responseType: 'blob'
  });
};

// Bulk create trainings from Excel file
export const BULK_CREATE_TRAININGS = (formData) => {
  return axiosIns.post('/training/bulk-create', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const BULK_CREATE_HISTORY_TRAININGS = (formData) => {
  return axiosIns.post('/training/history-catalog/bulk-create', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Search employees
export const SEARCH_EMPLOYEES = (searchQuery) => {
  return axiosInsAcademy.get('/employees/search', { params: { search: searchQuery } });
};

export const SYNC_EMPLOYEE_ON_DEMAND = (nik) => {
  return axiosInsAcademy.post('/employees/on-demand-sync', { nik });
};

// Add participant to training event/batch
export const ADD_PARTICIPANT = (trainingEventId, data) => {
  return axiosIns.post(`/training-event/${trainingEventId}/add-participant`, data);
};

// Get participants of a training event/batch
export const GET_PARTICIPANTS = (trainingEventId, params) => {
  return axiosIns.get(`/training-event/${trainingEventId}/participants`, { params });
};

export const DELETE_PARTICIPANT = (trainingEventId, nik) => {
  return axiosIns.delete(`/training-event/${trainingEventId}/participants/${encodeURIComponent(nik)}`);
};

export const SYNC_MOODLE_COMPLETION = (trainingEventId) => {
  return axiosIns.get('/bib-academy/trigger-completion', {
    params: {
      batch_ids: trainingEventId,
      check_by: 'scores'
    },
    timeout: MOODLE_CLONE_TIMEOUT_MS
  });
};

// Download batch participants report as Excel
export const DOWNLOAD_BATCH_REPORT = (trainingEventId, params) => {
  return axiosIns.get(`/training-event/${trainingEventId}/report`, {
    params,
    responseType: 'blob'
  });
};

// Download all certificates as zip
export const DOWNLOAD_ALL_CERTIFICATES = (trainingEventId, params = {}) => {
  return axiosIns.get(`/training-event/${trainingEventId}/certificates`, {
    params,
    responseType: 'blob'
  });
};
